import * as Types from '../../../api';

import { gql } from '@apollo/client';
import { IvrProfileContentFragmentDoc } from '../../ivr/profiles/queries.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainExportAddressBookQueryVariables = Types.Exact<{
  domainName: Types.Scalars['String']['input'];
}>;


export type DomainExportAddressBookQuery = { __typename?: 'Query', addressBook: { __typename?: 'AddressBookListResult', rows?: Array<{ __typename?: 'AddressBookEntry', sn: string, telephoneNumber: Array<string>, mobile?: string | null, homePhone?: string | null, givenName?: string | null, mail?: string | null, departmentNumber?: string | null, description?: string | null, o?: string | null, uid?: string | null }> | null } };

export type DomainExportQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainExportQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', id: number, name: string, domainType: Types.DomainType, description: string, specialNumbersDialoutPrefix?: string | null, shortNumbersLength: number, preferDisplayNamesForStationNames: boolean, smtpUsername?: string | null, smtpUserpass?: string | null, smtpAuthEnabled?: boolean | null, pinBasedCalls?: boolean | null, statisticsEmail?: string | null, defaultClientCapabilities: number, dialoutPrefix?: string | null, attendantPrefix?: string | null, baseColor?: string | null, ldapPassword: string, billingId: string, accountingCommunity?: string | null, loginBackgroundColor?: string | null, outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null, backgroundIsCenter?: boolean | null, adminCreateDeleteEndpointsEnabled: boolean, endpointE164RangesForAdmins?: string | null, privateRoutingType: Types.PrivateRoutingType, companyName?: string | null, groupDomain?: string | null, faxSignature?: string | null, monthlyLimit?: number | null, monthlyLimitExtensionDefault?: number | null, startingBalance?: number | null, tariffPackageIdDefault?: number | null, monthlyLimitServicePlanDefault?: number | null, priceLimitExtensionDefault?: number | null, timeLimitExtensionDefault?: number | null, useOcs?: boolean | null, sendAccounting?: boolean | null, defaultCapabilitySetForExtensions?: Array<string | null> | null, defaultDeviceLimits?: any | null, defaultUserPackage?: string | null, requirePinForStartingPrivateCalls: boolean, recordingLocation?: string | null, recordingRetention?: number | null, quotaGroup5: number, quotaGroup10: number, quotaGroup20: number, quotaFax: number, quotaCcBase: boolean, quotaIvr: number, quotaCallQueue: number } | null> } | null, users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, outgoingCallBarringOperator?: any | null, mobileNumber: string, homeNumber: string, notificationEmail?: string | null, outgoingCallBarringAdmin?: any | null, lastCallReturn?: string | null, callPark: boolean, redirectToSecretary: boolean, enabled: boolean, speeddial8: boolean, speeddial100: boolean, directInwardDialing: boolean, needWebPasswordChange: boolean, ldapPassword?: string | null, alternateCallerNumberId?: number | null, alias?: string | null, voicemailToEmailEnabled: boolean, previewFeaturesEnabled: boolean, cliro: boolean, maliciousCallTrace: boolean, directOutwardDialing: boolean, nationalCac: string, internationalCac: string, callLimit: number, hotnumber?: string | null, lastCallId?: string | null, outgoingCallBarringUser?: any | null, connectedNumberPresentationRestrictionOverride: boolean, featuresRestrictions: Array<Types.FeatureRestriction | null>, xcapPassword: string, useOcs?: boolean | null, sendAccounting?: boolean | null, monthlyLimit?: number | null, pin: string, callWaiting: boolean, userPackageName?: string | null, userSub?: string | null, secretaryNumberId?: number | null, recordingType: Types.DirectionType, privateRoutingType: Types.PrivateRoutingType, number?: { __typename?: 'Number', id: number, e164?: any | null, shortNumber?: string | null, collectStatistics: Types.DirectionType, callOriginationDenied: boolean, callTerminationDenied: boolean, clientInfo?: string | null, groupCircularSelectLastTs?: any | null, enabled: boolean, nonPaymentBlockingType: Types.NonPaymentBlockingType } | null, location?: { __typename?: 'Location', name: string } | null } | null> } | null, locations?: { __typename?: 'LocationList', items: Array<{ __typename?: 'Location', name: string, description: string, callLimit: number, bandwidthLimit: number, ipAddress?: string | null, pilotNumber: string, emergencyPrefix?: string | null } | null> } | null, ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null, name: string, outgoingCallBarringUser?: any | null, callLimit: number, recordingType: Types.DirectionType, number?: { __typename?: 'Number', id: number, e164?: any | null, shortNumber?: string | null, collectStatistics: Types.DirectionType, callOriginationDenied: boolean, callTerminationDenied: boolean, clientInfo?: string | null, groupCircularSelectLastTs?: any | null, enabled: boolean, nonPaymentBlockingType: Types.NonPaymentBlockingType } | null, profiles: Array<{ __typename?: 'IvrProfile', id: number, name: string, instantConnect: boolean, active: boolean, stickyProfile: boolean, timeout: number, activationTimes: Array<{ __typename?: 'IvrProfileActivationTime', weekday: Types.Weekday, activationTime: string }>, specialDays: Array<{ __typename?: 'IvrProfileSpecialDay', day: string, everyYear: boolean, activationTime?: string | null }>, submenus: Array<{ __typename?: 'IvrProfile', id: number, instantConnect: boolean, timeout: number, ivr?: { __typename?: 'Ivr', number?: { __typename?: 'Number', id: number } | null } | null, actions: Array<{ __typename?: 'IvrAction', id: number, ivrActionType?: Types.IvrActionType | null, button: number, targetNumberId?: number | null, targetNumber?: string | null, downloadToken?: string | null, connectionPrompt?: { __typename?: 'Media', id: number, description?: string | null } | null }>, greetings: Array<{ __typename?: 'IvrGreeting', orderNumber: number, isGreeting: boolean, downloadToken?: string | null, disabled: boolean, media?: { __typename?: 'Media', id: number, description?: string | null } | null }> }>, actions: Array<{ __typename?: 'IvrAction', id: number, ivrActionType?: Types.IvrActionType | null, button: number, targetNumberId?: number | null, targetNumber?: string | null, downloadToken?: string | null, connectionPrompt?: { __typename?: 'Media', id: number, description?: string | null } | null }>, greetings: Array<{ __typename?: 'IvrGreeting', orderNumber: number, isGreeting: boolean, downloadToken?: string | null, disabled: boolean, media?: { __typename?: 'Media', id: number, description?: string | null } | null }> }> } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string, pickup: boolean, sequentialTimeout?: number | null, maxQueueLength: number, maxWaitingTime: number, outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null, state?: Types.GroupState | null, hasAddressBook: boolean, groupType: Types.GroupType, size?: number | null, huntingAlgorithmType: Types.HuntingAlgorithmType, number?: { __typename?: 'Number', id: number, shortNumber?: string | null, e164?: any | null } | null, members: Array<{ __typename?: 'GroupMembership', callOrder?: number | null, sectionIndex: number, controllingLine: boolean, state: string, allowEditAddressBook: boolean, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null }> } | null> } | null, groupsQueue?: { __typename?: 'GroupsQueueList', items: Array<{ __typename?: 'GroupsQueue', groupId: number, acwLength?: number | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null, incomingEmailAddress?: string | null, headerNumber: string, headerInfo: string, senderEmailAddress?: string | null, password: string, notifyUnsuccessfulReceiving: boolean, number?: { __typename?: 'Number', id: number, e164?: any | null, shortNumber?: string | null, collectStatistics: Types.DirectionType, callOriginationDenied: boolean, callTerminationDenied: boolean, clientInfo?: string | null, groupCircularSelectLastTs?: any | null, enabled: boolean, nonPaymentBlockingType: Types.NonPaymentBlockingType } | null } | null> } | null, faxesEmails?: { __typename?: 'FaxesEmailList', items: Array<{ __typename?: 'FaxesEmail', id: number, extensionId: number, enableBodyProcess?: boolean | null, enableProgressFeedback?: boolean | null, faxId: number, extension?: { __typename?: 'User', displayName: string, notificationEmail?: string | null, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null> } | null, gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, sipUser: string, sipPassword: string, outgoingCallBarringOperator?: any | null, enabled: boolean, callbackNumberId?: number | null, lastCallDirection?: string | null, lastCallTime?: string | null, callbackType: Types.CallbackType, multipleCallsNumber: number, registrationTime?: any | null, registrationExpireTime?: any | null, ipAddress?: string | null, contactAddress?: string | null, clientInfo?: string | null, number?: { __typename?: 'Number', id: number, e164?: any | null, shortNumber?: string | null, collectStatistics: Types.DirectionType, callOriginationDenied: boolean, callTerminationDenied: boolean, clientInfo?: string | null, groupCircularSelectLastTs?: any | null, enabled: boolean, nonPaymentBlockingType: Types.NonPaymentBlockingType } | null } | null> } | null, privateRouting?: { __typename?: 'PrivateRoutingList', items: Array<{ __typename?: 'PrivateRouting', id: number, priority: number, gatewayId: number, comment?: string | null, destination?: { __typename?: 'Destination', name: string } | null } | null> } | null };

export type ExtensionProfileExportQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionProfileExportQuery = { __typename?: 'Query', userProfiles?: Array<{ __typename?: 'UserProfile', id: number, active: boolean, anonymousCallRejection: boolean, callForwardBusy: boolean, callForwardBusyNumber: string, callForwardBusySavedNumber: string, callForwardFault: boolean, callForwardFaultNumber: string, callForwardFaultSavedNumber: string, callForwardNoanswer: boolean, callForwardNoanswerNumber: string, callForwardNoanswerSavedNumber: string, callForwardNoanswerTimeout: number, callForwardUnavailable: boolean, callForwardUnavailableNumber: string, callForwardUnavailableSavedNumber: string, callForwardUnconditional: boolean, callForwardUnconditionalNumber: string, callForwardUnconditionalSavedNumber: string, callingNamePresentation: boolean, callingNumberPresentationRestriction: boolean, connectedNumberPresentationRestriction: boolean, doNotDisturb: boolean, locked?: boolean | null, name: string, parallelRinging: boolean, parallelRingingNumber: string, parallelRingingSavedNumber: string, rejectDivertedCalls: boolean, secretaryMode: Types.SecretaryMode, stickyProfile: boolean, activationTimes: Array<{ __typename?: 'UserProfileActivationTime', weekday: Types.Weekday, activationTime: string }>, specialDays: Array<{ __typename?: 'UserProfileSpecialDay', day: string, everyYear: boolean, activationTime?: string | null }>, rules: Array<{ __typename?: 'UserProfileRule', priority: number, sourceNumber: string, action: Types.ExtensionProfileRuleAction, targetNumber: string, matchType?: Types.UserProfileRuleMatchType | null }> } | null> | null };

export type ExtensionDevicesExportQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionDevicesExportQuery = { __typename?: 'Query', clientDevices: Array<{ __typename?: 'ClientDevice', id: number, type: string, description?: string | null }>, thirdPartyDevices?: Array<{ __typename?: 'ThirdPartyDevice', id: number, registrationTime?: any | null, registrationExpireTime?: any | null, sipUser: string, sipPassword: string, clientInfo?: string | null, gruu?: string | null, description?: string | null } | null> | null, provisionedDevices?: Array<{ __typename?: 'ProvisionedDevice', id: number, macAddress?: string | null, variant?: string | null, registrationTime?: any | null, registrationExpireTime?: any | null, sipPassword: string, sipUser: string, clientInfo?: string | null, provisioning: boolean, useDisplayNameForStationName: boolean, vendor: { __typename?: 'Vendor', id: number, name: string } } | null> | null };

export type ExtensionLimitsExportQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionLimitsExportQuery = { __typename?: 'Query', userQuotaInfo?: { __typename?: 'UserQuotaInfo', capabilitySets: Array<string>, deviceTypeSets: Array<{ __typename?: 'UserDeviceTypeSetQuota', name: string, value?: number | null, used: number }> } | null };

export type DomainAllocationExportQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainAllocationExportQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', userPackages: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number }>, deviceTypeSets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number }>, capabilitySets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number }>, services: { __typename?: 'ServiceDomainAllocationsInfo', fax: { __typename?: 'DomainAllocationInfo', domainAllocated: number }, ccBase: { __typename?: 'SingleItemDomainAllocationInfo', domainAllocated: boolean }, ccAattendant: { __typename?: 'DomainAllocationInfo', domainAllocated: number }, ccQueue: { __typename?: 'DomainAllocationInfo', domainAllocated: number }, group5: { __typename?: 'DomainAllocationInfo', domainAllocated: number }, group10: { __typename?: 'DomainAllocationInfo', domainAllocated: number }, group20: { __typename?: 'DomainAllocationInfo', domainAllocated: number } } } };

export type PhoneButtonsQueryVariables = Types.Exact<{
  provisionedDeviceId: Types.Scalars['Int']['input'];
}>;


export type PhoneButtonsQuery = { __typename?: 'Query', phoneButtons?: Array<{ __typename?: 'PhoneButton', buttonType: Types.PhoneButtonType, buttonPosition: number, targetNumberId?: number | null, speedDialNumber?: string | null, display?: string | null } | null> | null };

export type SpeedDialsExportQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type SpeedDialsExportQuery = { __typename?: 'Query', speedDials?: { __typename?: 'SpeedDialList', items: Array<{ __typename?: 'SpeedDial', shortNumber: string, targetNumber: string, description?: string | null } | null> } | null };


export const DomainExportAddressBookDocument = gql`
    query DomainExportAddressBook($domainName: String!) {
  addressBook(target: $domainName) {
    rows {
      sn
      telephoneNumber
      mobile
      homePhone
      givenName
      mail
      departmentNumber
      description
      o
      uid
    }
  }
}
    `;

/**
 * __useDomainExportAddressBookQuery__
 *
 * To run a query within a React component, call `useDomainExportAddressBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainExportAddressBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainExportAddressBookQuery({
 *   variables: {
 *      domainName: // value for 'domainName'
 *   },
 * });
 */
export function useDomainExportAddressBookQuery(baseOptions: Apollo.QueryHookOptions<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables> & ({ variables: DomainExportAddressBookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables>(DomainExportAddressBookDocument, options);
      }
export function useDomainExportAddressBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables>(DomainExportAddressBookDocument, options);
        }
export function useDomainExportAddressBookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables>(DomainExportAddressBookDocument, options);
        }
export type DomainExportAddressBookQueryHookResult = ReturnType<typeof useDomainExportAddressBookQuery>;
export type DomainExportAddressBookLazyQueryHookResult = ReturnType<typeof useDomainExportAddressBookLazyQuery>;
export type DomainExportAddressBookSuspenseQueryHookResult = ReturnType<typeof useDomainExportAddressBookSuspenseQuery>;
export type DomainExportAddressBookQueryResult = Apollo.QueryResult<DomainExportAddressBookQuery, DomainExportAddressBookQueryVariables>;
export const DomainExportDocument = gql`
    query DomainExport($domainId: Int!) {
  domains(id: $domainId) {
    items {
      id
      name
      domainType
      description
      specialNumbersDialoutPrefix
      shortNumbersLength
      preferDisplayNamesForStationNames
      smtpUsername
      smtpUserpass
      smtpAuthEnabled
      pinBasedCalls
      statisticsEmail
      defaultClientCapabilities
      dialoutPrefix
      attendantPrefix
      baseColor
      ldapPassword
      billingId
      accountingCommunity
      loginBackgroundColor
      outgoingCallBarringOperator
      outgoingCallBarringAdmin
      backgroundIsCenter
      adminCreateDeleteEndpointsEnabled
      endpointE164RangesForAdmins
      privateRoutingType
      companyName
      groupDomain
      faxSignature
      monthlyLimit
      monthlyLimitExtensionDefault
      startingBalance
      tariffPackageIdDefault
      monthlyLimitServicePlanDefault
      priceLimitExtensionDefault
      timeLimitExtensionDefault
      useOcs
      sendAccounting
      defaultCapabilitySetForExtensions
      defaultDeviceLimits
      defaultUserPackage
      requirePinForStartingPrivateCalls
      recordingLocation
      recordingRetention
      quotaGroup5
      quotaGroup10
      quotaGroup20
      quotaFax
      quotaCcBase
      quotaIvr
      quotaCallQueue
    }
  }
  users(domainId: $domainId) {
    items {
      id
      number {
        id
        e164
        shortNumber
        collectStatistics
        callOriginationDenied
        callTerminationDenied
        clientInfo
        groupCircularSelectLastTs
        enabled
        nonPaymentBlockingType
      }
      location {
        name
      }
      displayName
      outgoingCallBarringOperator
      mobileNumber
      homeNumber
      notificationEmail
      outgoingCallBarringAdmin
      lastCallReturn
      callPark
      redirectToSecretary
      enabled
      speeddial8
      speeddial100
      directInwardDialing
      needWebPasswordChange
      ldapPassword
      alternateCallerNumberId
      alias
      voicemailToEmailEnabled
      previewFeaturesEnabled
      cliro
      maliciousCallTrace
      directOutwardDialing
      nationalCac
      internationalCac
      callLimit
      hotnumber
      lastCallId
      outgoingCallBarringUser
      connectedNumberPresentationRestrictionOverride
      featuresRestrictions
      xcapPassword
      useOcs
      sendAccounting
      monthlyLimit
      pin
      callWaiting
      userPackageName
      userSub
      secretaryNumberId
      recordingType
      privateRoutingType
    }
  }
  locations(domainId: $domainId) {
    items {
      name
      description
      callLimit
      bandwidthLimit
      ipAddress
      pilotNumber
      emergencyPrefix
    }
  }
  ivrs(domainId: $domainId) {
    items {
      outgoingCallBarringOperator
      outgoingCallBarringAdmin
      name
      outgoingCallBarringUser
      callLimit
      recordingType
      number {
        id
        e164
        shortNumber
        collectStatistics
        callOriginationDenied
        callTerminationDenied
        clientInfo
        groupCircularSelectLastTs
        enabled
        nonPaymentBlockingType
      }
      profiles {
        id
        name
        instantConnect
        active
        stickyProfile
        ...IvrProfileContent
        activationTimes {
          weekday
          activationTime
        }
        specialDays {
          day
          everyYear
          activationTime
        }
        submenus {
          id
          ivr {
            number {
              id
            }
          }
          ...IvrProfileContent
        }
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      name
      pickup
      sequentialTimeout
      maxQueueLength
      maxWaitingTime
      outgoingCallBarringOperator
      outgoingCallBarringAdmin
      state
      hasAddressBook
      groupType
      size
      number {
        id
        shortNumber
        e164
      }
      members {
        number {
          shortNumber
        }
        callOrder
        sectionIndex
        controllingLine
        state
        allowEditAddressBook
        numberId
      }
      huntingAlgorithmType
    }
  }
  groupsQueue {
    items {
      groupId
      acwLength
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      outgoingCallBarringOperator
      outgoingCallBarringAdmin
      incomingEmailAddress
      headerNumber
      headerInfo
      senderEmailAddress
      password
      notifyUnsuccessfulReceiving
      number {
        id
        e164
        shortNumber
        collectStatistics
        callOriginationDenied
        callTerminationDenied
        clientInfo
        groupCircularSelectLastTs
        enabled
        nonPaymentBlockingType
      }
    }
  }
  faxesEmails {
    items {
      id
      extensionId
      enableBodyProcess
      enableProgressFeedback
      extension {
        displayName
        number {
          shortNumber
        }
        notificationEmail
      }
      faxId
    }
  }
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      sipUser
      sipPassword
      outgoingCallBarringOperator
      enabled
      callbackNumberId
      lastCallDirection
      lastCallTime
      callbackType
      multipleCallsNumber
      registrationTime
      registrationExpireTime
      ipAddress
      contactAddress
      clientInfo
      number {
        id
        e164
        shortNumber
        collectStatistics
        callOriginationDenied
        callTerminationDenied
        clientInfo
        groupCircularSelectLastTs
        enabled
        nonPaymentBlockingType
      }
    }
  }
  privateRouting(domainId: $domainId) {
    items {
      id
      priority
      gatewayId
      comment
      destination {
        name
      }
    }
  }
}
    ${IvrProfileContentFragmentDoc}`;

/**
 * __useDomainExportQuery__
 *
 * To run a query within a React component, call `useDomainExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainExportQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainExportQuery(baseOptions: Apollo.QueryHookOptions<DomainExportQuery, DomainExportQueryVariables> & ({ variables: DomainExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainExportQuery, DomainExportQueryVariables>(DomainExportDocument, options);
      }
export function useDomainExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainExportQuery, DomainExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainExportQuery, DomainExportQueryVariables>(DomainExportDocument, options);
        }
export function useDomainExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainExportQuery, DomainExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainExportQuery, DomainExportQueryVariables>(DomainExportDocument, options);
        }
export type DomainExportQueryHookResult = ReturnType<typeof useDomainExportQuery>;
export type DomainExportLazyQueryHookResult = ReturnType<typeof useDomainExportLazyQuery>;
export type DomainExportSuspenseQueryHookResult = ReturnType<typeof useDomainExportSuspenseQuery>;
export type DomainExportQueryResult = Apollo.QueryResult<DomainExportQuery, DomainExportQueryVariables>;
export const ExtensionProfileExportDocument = gql`
    query ExtensionProfileExport($userId: Int!) {
  userProfiles(extensionId: $userId) {
    id
    active
    anonymousCallRejection
    callForwardBusy
    callForwardBusyNumber
    callForwardBusySavedNumber
    callForwardFault
    callForwardFaultNumber
    callForwardFaultSavedNumber
    callForwardNoanswer
    callForwardNoanswerNumber
    callForwardNoanswerSavedNumber
    callForwardNoanswerTimeout
    callForwardUnavailable
    callForwardUnavailableNumber
    callForwardUnavailableSavedNumber
    callForwardUnconditional
    callForwardUnconditionalNumber
    callForwardUnconditionalSavedNumber
    callingNamePresentation
    callingNumberPresentationRestriction
    connectedNumberPresentationRestriction
    doNotDisturb
    locked
    name
    parallelRinging
    parallelRingingNumber
    parallelRingingSavedNumber
    rejectDivertedCalls
    secretaryMode
    stickyProfile
    activationTimes {
      weekday
      activationTime
    }
    specialDays {
      day
      everyYear
      activationTime
    }
    rules {
      priority
      sourceNumber
      action
      targetNumber
      matchType
    }
  }
}
    `;

/**
 * __useExtensionProfileExportQuery__
 *
 * To run a query within a React component, call `useExtensionProfileExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionProfileExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionProfileExportQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionProfileExportQuery(baseOptions: Apollo.QueryHookOptions<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables> & ({ variables: ExtensionProfileExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables>(ExtensionProfileExportDocument, options);
      }
export function useExtensionProfileExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables>(ExtensionProfileExportDocument, options);
        }
export function useExtensionProfileExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables>(ExtensionProfileExportDocument, options);
        }
export type ExtensionProfileExportQueryHookResult = ReturnType<typeof useExtensionProfileExportQuery>;
export type ExtensionProfileExportLazyQueryHookResult = ReturnType<typeof useExtensionProfileExportLazyQuery>;
export type ExtensionProfileExportSuspenseQueryHookResult = ReturnType<typeof useExtensionProfileExportSuspenseQuery>;
export type ExtensionProfileExportQueryResult = Apollo.QueryResult<ExtensionProfileExportQuery, ExtensionProfileExportQueryVariables>;
export const ExtensionDevicesExportDocument = gql`
    query ExtensionDevicesExport($userId: Int!) {
  clientDevices(userId: $userId) {
    id
    type
    description
  }
  thirdPartyDevices(userId: $userId) {
    id
    registrationTime
    registrationExpireTime
    sipUser
    sipPassword
    clientInfo
    gruu
    description
  }
  provisionedDevices(userId: $userId) {
    id
    macAddress
    variant
    registrationTime
    registrationExpireTime
    sipPassword
    sipUser
    clientInfo
    provisioning
    useDisplayNameForStationName
    vendor {
      id
      name
    }
  }
}
    `;

/**
 * __useExtensionDevicesExportQuery__
 *
 * To run a query within a React component, call `useExtensionDevicesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionDevicesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionDevicesExportQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionDevicesExportQuery(baseOptions: Apollo.QueryHookOptions<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables> & ({ variables: ExtensionDevicesExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables>(ExtensionDevicesExportDocument, options);
      }
export function useExtensionDevicesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables>(ExtensionDevicesExportDocument, options);
        }
export function useExtensionDevicesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables>(ExtensionDevicesExportDocument, options);
        }
export type ExtensionDevicesExportQueryHookResult = ReturnType<typeof useExtensionDevicesExportQuery>;
export type ExtensionDevicesExportLazyQueryHookResult = ReturnType<typeof useExtensionDevicesExportLazyQuery>;
export type ExtensionDevicesExportSuspenseQueryHookResult = ReturnType<typeof useExtensionDevicesExportSuspenseQuery>;
export type ExtensionDevicesExportQueryResult = Apollo.QueryResult<ExtensionDevicesExportQuery, ExtensionDevicesExportQueryVariables>;
export const ExtensionLimitsExportDocument = gql`
    query ExtensionLimitsExport($userId: Int!) {
  userQuotaInfo(userId: $userId) {
    capabilitySets
    deviceTypeSets {
      name
      value
      used
    }
  }
}
    `;

/**
 * __useExtensionLimitsExportQuery__
 *
 * To run a query within a React component, call `useExtensionLimitsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionLimitsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionLimitsExportQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionLimitsExportQuery(baseOptions: Apollo.QueryHookOptions<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables> & ({ variables: ExtensionLimitsExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables>(ExtensionLimitsExportDocument, options);
      }
export function useExtensionLimitsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables>(ExtensionLimitsExportDocument, options);
        }
export function useExtensionLimitsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables>(ExtensionLimitsExportDocument, options);
        }
export type ExtensionLimitsExportQueryHookResult = ReturnType<typeof useExtensionLimitsExportQuery>;
export type ExtensionLimitsExportLazyQueryHookResult = ReturnType<typeof useExtensionLimitsExportLazyQuery>;
export type ExtensionLimitsExportSuspenseQueryHookResult = ReturnType<typeof useExtensionLimitsExportSuspenseQuery>;
export type ExtensionLimitsExportQueryResult = Apollo.QueryResult<ExtensionLimitsExportQuery, ExtensionLimitsExportQueryVariables>;
export const DomainAllocationExportDocument = gql`
    query DomainAllocationExport($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    userPackages {
      name
      domainAllocated
    }
    deviceTypeSets {
      name
      domainAllocated
    }
    capabilitySets {
      name
      domainAllocated
    }
    services {
      fax {
        domainAllocated
      }
      ccBase {
        domainAllocated
      }
      ccAattendant {
        domainAllocated
      }
      ccQueue {
        domainAllocated
      }
      group5 {
        domainAllocated
      }
      group10 {
        domainAllocated
      }
      group20 {
        domainAllocated
      }
    }
  }
}
    `;

/**
 * __useDomainAllocationExportQuery__
 *
 * To run a query within a React component, call `useDomainAllocationExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainAllocationExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainAllocationExportQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainAllocationExportQuery(baseOptions: Apollo.QueryHookOptions<DomainAllocationExportQuery, DomainAllocationExportQueryVariables> & ({ variables: DomainAllocationExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainAllocationExportQuery, DomainAllocationExportQueryVariables>(DomainAllocationExportDocument, options);
      }
export function useDomainAllocationExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainAllocationExportQuery, DomainAllocationExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainAllocationExportQuery, DomainAllocationExportQueryVariables>(DomainAllocationExportDocument, options);
        }
export function useDomainAllocationExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainAllocationExportQuery, DomainAllocationExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainAllocationExportQuery, DomainAllocationExportQueryVariables>(DomainAllocationExportDocument, options);
        }
export type DomainAllocationExportQueryHookResult = ReturnType<typeof useDomainAllocationExportQuery>;
export type DomainAllocationExportLazyQueryHookResult = ReturnType<typeof useDomainAllocationExportLazyQuery>;
export type DomainAllocationExportSuspenseQueryHookResult = ReturnType<typeof useDomainAllocationExportSuspenseQuery>;
export type DomainAllocationExportQueryResult = Apollo.QueryResult<DomainAllocationExportQuery, DomainAllocationExportQueryVariables>;
export const PhoneButtonsDocument = gql`
    query PhoneButtons($provisionedDeviceId: Int!) {
  phoneButtons(provisionedDeviceId: $provisionedDeviceId) {
    buttonType
    buttonPosition
    targetNumberId
    speedDialNumber
    display
  }
}
    `;

/**
 * __usePhoneButtonsQuery__
 *
 * To run a query within a React component, call `usePhoneButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneButtonsQuery({
 *   variables: {
 *      provisionedDeviceId: // value for 'provisionedDeviceId'
 *   },
 * });
 */
export function usePhoneButtonsQuery(baseOptions: Apollo.QueryHookOptions<PhoneButtonsQuery, PhoneButtonsQueryVariables> & ({ variables: PhoneButtonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhoneButtonsQuery, PhoneButtonsQueryVariables>(PhoneButtonsDocument, options);
      }
export function usePhoneButtonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhoneButtonsQuery, PhoneButtonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhoneButtonsQuery, PhoneButtonsQueryVariables>(PhoneButtonsDocument, options);
        }
export function usePhoneButtonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PhoneButtonsQuery, PhoneButtonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PhoneButtonsQuery, PhoneButtonsQueryVariables>(PhoneButtonsDocument, options);
        }
export type PhoneButtonsQueryHookResult = ReturnType<typeof usePhoneButtonsQuery>;
export type PhoneButtonsLazyQueryHookResult = ReturnType<typeof usePhoneButtonsLazyQuery>;
export type PhoneButtonsSuspenseQueryHookResult = ReturnType<typeof usePhoneButtonsSuspenseQuery>;
export type PhoneButtonsQueryResult = Apollo.QueryResult<PhoneButtonsQuery, PhoneButtonsQueryVariables>;
export const SpeedDialsExportDocument = gql`
    query SpeedDialsExport($userId: Int!) {
  speedDials(extensionId: $userId) {
    items {
      shortNumber
      targetNumber
      description
    }
  }
}
    `;

/**
 * __useSpeedDialsExportQuery__
 *
 * To run a query within a React component, call `useSpeedDialsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeedDialsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeedDialsExportQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSpeedDialsExportQuery(baseOptions: Apollo.QueryHookOptions<SpeedDialsExportQuery, SpeedDialsExportQueryVariables> & ({ variables: SpeedDialsExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeedDialsExportQuery, SpeedDialsExportQueryVariables>(SpeedDialsExportDocument, options);
      }
export function useSpeedDialsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeedDialsExportQuery, SpeedDialsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeedDialsExportQuery, SpeedDialsExportQueryVariables>(SpeedDialsExportDocument, options);
        }
export function useSpeedDialsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpeedDialsExportQuery, SpeedDialsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpeedDialsExportQuery, SpeedDialsExportQueryVariables>(SpeedDialsExportDocument, options);
        }
export type SpeedDialsExportQueryHookResult = ReturnType<typeof useSpeedDialsExportQuery>;
export type SpeedDialsExportLazyQueryHookResult = ReturnType<typeof useSpeedDialsExportLazyQuery>;
export type SpeedDialsExportSuspenseQueryHookResult = ReturnType<typeof useSpeedDialsExportSuspenseQuery>;
export type SpeedDialsExportQueryResult = Apollo.QueryResult<SpeedDialsExportQuery, SpeedDialsExportQueryVariables>;